import React from "react";

import { DynamicWhatsApp } from "../../../common/Chat";
import { Topbar } from "../../../../components/Header";
import { LandingContext } from "../../../products/context/landing";

const { Provider } = LandingContext;

export const Container: React.FC = ({ children }) => (
  <Provider value={{ formOpen: true, offersMode: false }}>
    <Topbar />
    {children}
    <DynamicWhatsApp hideInMobile={true} />
  </Provider>
);
